var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeployer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10049_974)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99074 0C2.68205 0 0 2.68205 0 5.99074C0 9.29942 2.68205 11.9815 5.99074 11.9815C9.29942 11.9815 11.9815 9.29942 11.9815 5.99074C11.9815 2.68205 9.29942 0 5.99074 0ZM3.89398 4.49305C3.89398 4.2177 3.94821 3.94505 4.05359 3.69066C4.15896 3.43627 4.3134 3.20512 4.50811 3.01042C4.70281 2.81572 4.93395 2.66127 5.18834 2.5559C5.44273 2.45053 5.71539 2.39629 5.99074 2.39629C6.26609 2.39629 6.53874 2.45053 6.79313 2.5559C7.04752 2.66127 7.27867 2.81572 7.47337 3.01042C7.66807 3.20512 7.82252 3.43627 7.92789 3.69066C8.03326 3.94505 8.0875 4.2177 8.0875 4.49305C8.0875 5.04915 7.86659 5.58247 7.47337 5.97568C7.08015 6.3689 6.54683 6.58981 5.99074 6.58981C5.43464 6.58981 4.90132 6.3689 4.50811 5.97568C4.11489 5.58247 3.89398 5.04915 3.89398 4.49305ZM9.73974 8.97652C9.29115 9.54046 8.72102 9.99583 8.07188 10.3087C7.42273 10.6215 6.71133 10.7838 5.99074 10.7833C5.27014 10.7838 4.55874 10.6215 3.9096 10.3087C3.26046 9.99583 2.69033 9.54046 2.24173 8.97652C3.21283 8.2798 4.53798 7.78796 5.99074 7.78796C7.44349 7.78796 8.76864 8.2798 9.73974 8.97652Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10049_974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeployer);
export default __webpack_public_path__ + "static/media/deployer.8361c79235c5e5f632370a8942fcda6d.svg";
export { ForwardRef as ReactComponent };